import EfLink from '@elem/ui/ef-link';
import EcoIconSwiperArrow from 'eco-design-micro/icons/eco-icon-swiper-arrow';
import GloLayout from 'lowcode/common/GloLayout';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { queryCategoryItems } from '../../common/blog-api/queryCategoryItems';
import { LangText } from '../../common/blog-lang-text';
import BlogTimer from '../../common/blog-timer';
import { getBlogTagFromList } from '../../common/utils';
import BlogCategoryBCard from './blog-category-b-card';

export default function Content({ id, data, initIndex = 0, isEditStatus = false }: any) {
    const { layout = 'text-hover', categoryId, categoryName, items = [] } = data;
    const { locale = 'us' } = useRouter();
    const TextA = LangText[locale] || LangText['us'];
    const categoryHref = `/${locale}/blog/category/${categoryId}`;
    const [categoryNameA, setCategoryNameA] = useState(categoryName);
    const [itemsA, setItemsA] = useState(items);
    useEffect(() => {
        const getItemsForNone = async () => {
            const dataA = await queryCategoryItems(locale, {
                categoryId: categoryId,
            });
            setCategoryNameA(dataA?.categoryName);
            setItemsA(dataA.items);
        };
        if (items.length === 0 && categoryId) {
            getItemsForNone();
        }
    }, [categoryId, items.length]);

    const [spaceBetweenW, setSpaceBetweenW] = useState(24); //左右间隔
    useEffect(() => {
        const initHandle = () => {
            // 初始化间隔
            const clientWidth = document.body.clientWidth;
            if (clientWidth >= 1024) {
                setSpaceBetweenW(24);
            } else {
                setSpaceBetweenW(24);
            }
        };
        initHandle();
    }, []);
    return (
        <GloLayout className="editor-blog-category-b" id={id}>
            <div className="editor-blog-category-b-h eco-content">
                <h2 className="editor-blog-category-b-h-l">{categoryNameA}</h2>
                <div className="editor-blog-category-b-h-r">
                    <EfLink href={categoryHref} className="editor-blog-category-b-h-btn">
                        {TextA.ViewAll}
                    </EfLink>
                </div>
            </div>
            <Swiper
                className="editor-blog-category-b-c"
                slidesPerView={'auto'}
                centeredSlides
                spaceBetween={spaceBetweenW}
                modules={[Navigation, Pagination]}
                initialSlide={1}
                navigation={{
                    nextEl: '.blog-swiper-button-next',
                    prevEl: '.blog-swiper-button-prev',
                }}
            >
                {itemsA?.map((item: any, index: number) => {
                    const thePage = JSON.parse(item.thePage || '{}');
                    const tagItem = getBlogTagFromList(item.blogTagList || [], categoryId);

                    return (
                        <SwiperSlide key={index}>
                            <BlogCategoryBCard
                                categoryHref={`/${locale}/blog/category/${categoryId}`}
                                label={tagItem.tag}
                                title={thePage.blogTitle}
                                pc={thePage.blogImgPc}
                                h5={thePage.blogImgH5}
                                href={item.seoUrl}
                                layout={layout}
                                timer={BlogTimer(item.newFirstReleaseTime || item.firstReleaseTime, locale)}
                            />
                        </SwiperSlide>
                    );
                })}
                <div className={`blog-swiper-control`}>
                    <div className="blog-swiper-navigation">
                        <div className="blog-swiper-button-prev">
                            <EcoIconSwiperArrow className="blog-swiper-button-icon" />
                        </div>
                        <div className="blog-swiper-button-next">
                            <EcoIconSwiperArrow className="blog-swiper-button-icon" />
                        </div>
                    </div>
                </div>
            </Swiper>
        </GloLayout>
    );
}
